var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavigationGlobalMenuOutlineOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 10.85a1.333 1.333 0 110 2.666 1.333 1.333 0 010-2.666zm5.333 0a1.333 1.333 0 110 2.666 1.333 1.333 0 010-2.666zm-10.666 0a1.333 1.333 0 110 2.666 1.333 1.333 0 010-2.666zm5.333-6a1.333 1.333 0 110 2.666 1.333 1.333 0 010-2.666zm5.333 0a1.333 1.333 0 110 2.666 1.333 1.333 0 010-2.666zm-10.666 0a1.333 1.333 0 110 2.666 1.333 1.333 0 010-2.666zm5.333 12a1.333 1.333 0 110 2.666 1.333 1.333 0 010-2.666zm5.333 0a1.333 1.333 0 110 2.666 1.333 1.333 0 010-2.666zm-10.666 0a1.333 1.333 0 110 2.666 1.333 1.333 0 010-2.666z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationGlobalMenuOutlineOutline);
export default __webpack_public_path__ + "260b7fc090ebeb664b391ea462435fc4.svg";
export { ForwardRef as ReactComponent };